export const FETCH_ALL_REQUEST = "Priorities/FETCH_ALL_REQUEST";
export const FETCH_ALL_SUCCESS = "Priorities/FETCH_ALL_SUCCESS";
export const FILTER_CHANGED = "Priorities/FILTER_CHANGED";

export const CREATE_SUCCESS = "Priorities/CREATE_SUCCESS";

export const REDUCER_NAME = "priorities";
